(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.directive('protocolItem', [ProtocolItemFn]);


    function ProtocolItemFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/protocols/templates/protocol-item.template.html',
            controller: 'ProtocolItemController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                protocol: '=',
                overview: '=',
                selectedUser: '='
            }
        };
        return directive;

    }

})();